/** Canonical educator dashboard document list (`profile_document_upload` via SP `p_profile_upload`). */
export function profileUploadDocumentsFromDashboardRow(
  row: Record<string, unknown> | null | undefined
): Record<string, unknown>[] {
  if (!row) {
    return [];
  }
  const uploads = row['p_profile_upload'];
  return Array.isArray(uploads) ? (uploads as Record<string, unknown>[]) : [];
}
